import { ChatMessage } from '../model/chat-message';
import { MessageType } from '../model/message-type';
import { PredefinedMessage } from '../model/predefined-message';

export const DECLARED_ICONS: IconMessageTypeMap[] = [
    { icon: 'error_circle', type: MessageType.ERROR, name: 'error' },
    { icon: 'info-message', type: MessageType.INFO, name: 'info' },
    { icon: 'warning-message', type: MessageType.ALARM, name: 'warning' },
    { icon: 'confirm-message', type: MessageType.WARNING, name: 'confirm' }
  ];

export function convertMessageToPredefined(chatMessage: ChatMessage): PredefinedMessage {
    return Object.assign(new PredefinedMessage(), {
        message: chatMessage.message,
        icon: DECLARED_ICONS.find(decIcon => decIcon.type === chatMessage.type)?.icon
    });
}

export function convertPredefinedToMessage(predMessage: PredefinedMessage): ChatMessage {
    return Object.assign(new ChatMessage(), {
        message: predMessage.message,
        type: DECLARED_ICONS.find(decIcon => decIcon.icon === predMessage.icon)?.type || MessageType.INFO
    });
}

export function defaultMessage(): ChatMessage {
    return Object.assign(new ChatMessage(), {
      message: '',
      type: MessageType.INFO
    });
  }

export function getNameByIcon(icon: string): string {
  return DECLARED_ICONS.find(i => i.icon === icon)?.name;
}

interface IconMessageTypeMap {
    icon: string;
    type: MessageType;
    name: string;
}
